// ============================================================================
// MASTER SIDEBAR REPOSITORY
// ARQUIVO: src/services/MasterSidebarRepository.js
// RESPONSABILIDADE: Operações Firestore do MasterSidebar (triage, alerts).
// Criado: Fase 6.3 — mover Firestore direto de MasterSidebar.jsx para repositório.
// ============================================================================

import { collection, limit, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

/** Observa triagem (fallback legacy). */
export function watchLegacyTriage(onData, onError) {
  return onSnapshot(collection(db, 'rda_triage'), onData, onError);
}

/** Observa triagem do app. */
export function watchAppTriage(appId, onData, onError) {
  return onSnapshot(
    collection(db, 'artifacts', appId, 'public', 'data', 'rda_triage'),
    onData,
    onError
  );
}

/** Observa alertas não lidos. */
export function watchUnreadAlerts(onData, onError) {
  const qAlerts = query(
    collection(db, 'alert_inbox'),
    where('is_read', '==', false),
    limit(100),
  );
  return onSnapshot(qAlerts, onData, onError);
}
